import React from 'react'

import Grid from 'components/Grid'
import Link from 'components/Link'
import ReviewMethodologyModal from 'components/ReviewMethodologyModal'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { useListingDetailContext } from 'context/ListingDetailContext'

import AllFeaturesSearch from './components/AllFeaturesSearch'
import FeaturesAIList from './components/FeaturesAIList '
import FeaturesList from './components/FeaturesList'

import classes from './KeyFeatures.module.scss'

/** @type {import("./types").default} */
const KeyFeatures = () => {
  const { listing } = useListingDetailContext()
  const { addEvent } = useEventContext()

  const { features } = listing
  const hasKeyFeatures = !!features?.enhanced_features.length

  const isAISummary = !!features?.heading

  let text = ''
  if (features?.heading) {
    text = features?.heading
      .replace("GetApp's analysis", '')
      .replace('identified', 'identifies')
      .replace('how it performs according to users.', 'summarizes user sentiment about those features.')
  }

  return (
    <Grid className="Features" spacing={4} container>
      {hasKeyFeatures && (
        <>
          {!isAISummary && (
            <Typography className={classes.defaultHeading}>
              Most critical features, based on insights from {listing.name} users:
            </Typography>
          )}

          <Grid item xs={12}>
            {isAISummary ? (
              <>
                <Typography variant="body-sm" className={classes.aiHeading}>
                  <Link
                    href="/resources/software-research-methodology/"
                    target="_blank"
                    className={classes.link}
                    {...addEvent({
                      name: 'engagement_facet_click',
                      engagementComponent: 'product_key-features',
                      engagementDestination: 'go_to_blog_research_methodology',
                      engagementDetails: 'getapps-analysis-link',
                    })}
                  >
                    GetApp&apos;s analysis
                  </Link>{' '}
                  {text} <ReviewMethodologyModal targetComponent="product_key-features" />
                </Typography>
              </>
            ) : (
              <FeaturesList defaultList={features.enhanced_features} />
            )}
          </Grid>

          {isAISummary && (
            <Grid item xs={12}>
              <FeaturesAIList summaryList={features.enhanced_features} />
            </Grid>
          )}
        </>
      )}

      <Grid item xs={12}>
        <AllFeaturesSearch />
      </Grid>
    </Grid>
  )
}

export default KeyFeatures
